import {attribute, bool, oneOf, string, type SchemaToProps} from '../../runtime';
import {ORIENTATIONS, type Orientation} from '../common';

const FIELD_LAYOUTS = ['stack', 'grid', 'inline'] as const;
const FIELD_GROUP_LAYOUTS = ['stack', 'row', 'grid'] as const;
const FIELD_ORIENTATIONS = ORIENTATIONS;

type FieldLayout = typeof FIELD_LAYOUTS[number];
type FieldGroupLayout = typeof FIELD_GROUP_LAYOUTS[number];
type FieldOrientation = Orientation;

const fieldSchema = {
    name: string,
    controlId: string,
    label: string,
    description: string,
    descriptionTrailing: string,
    error: string,
    errors: string,
    badge: string,
    orientation: oneOf(FIELD_ORIENTATIONS, 'vertical' as FieldOrientation),
    layout: oneOf(FIELD_LAYOUTS, 'stack' as FieldLayout),
    disabled: bool,
    required: bool,
    invalid: bool,
    class: string,
};

const fieldLabelSchema = {
    controlId: string,
    badge: string,
    required: bool,
    class: string,
};

const fieldDescriptionSchema = {
    id: string,
    placement: oneOf(['default', 'trailing'] as const, 'default'),
    class: string,
};

const fieldErrorSchema = {
    id: string,
    message: string,
    errors: string,
    class: string,
};

const fieldGroupSchema = {
    layout: oneOf(FIELD_GROUP_LAYOUTS, 'stack' as FieldGroupLayout),
    class: string,
};

const fieldsetSchema = {
    name: string,
    legend: string,
    description: string,
    error: string,
    errors: string,
    layout: oneOf(FIELD_LAYOUTS, 'stack' as FieldLayout),
    disabled: bool,
    required: bool,
    invalid: bool,
    class: string,
};

const fieldsetLegendSchema = {
    badge: string,
    required: bool,
    class: string,
};

const fieldRuntimeSchema = {
    invalid: attribute(bool, 'prop-invalid'),
};

type FieldProps = SchemaToProps<typeof fieldSchema>;
type FieldGroupProps = SchemaToProps<typeof fieldGroupSchema>;
type FieldRuntimeProps = SchemaToProps<typeof fieldRuntimeSchema>;
type FieldsetProps = SchemaToProps<typeof fieldsetSchema>;

export {
    FIELD_GROUP_LAYOUTS,
    FIELD_LAYOUTS,
    FIELD_ORIENTATIONS,
    fieldDescriptionSchema,
    fieldErrorSchema,
    fieldGroupSchema,
    fieldLabelSchema,
    fieldRuntimeSchema,
    fieldSchema,
    fieldsetLegendSchema,
    fieldsetSchema,
};
export type {FieldGroupLayout, FieldGroupProps, FieldLayout, FieldOrientation, FieldProps, FieldRuntimeProps, FieldsetProps};
